define('OutSystems/ClientRuntime/modules/Database/IDatabase',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.instanceOfIDatabase = void 0;
    function instanceOfIDatabase(object) {
        return ("name" in object &&
            "registerInitializer" in object &&
            "initialize" in object &&
            "initializerCleanup" in object &&
            "testConnection" in object &&
            "close" in object &&
            "executeReadTransaction" in object &&
            "executeTransaction" in object &&
            "executeUpgradeTransaction" in object);
    }
    exports.instanceOfIDatabase = instanceOfIDatabase;
});
//# sourceMappingURL=IDatabase.js.map;
